import { createSystem, defaultConfig, defineTextStyles } from "@chakra-ui/react";

const breakpoints = {
  base: "0em",
  sm: "480px",
  md: "768px",
  lg: "992px",
  xl: "1280px",
  "2xl": "1536px",
};

// const scale = {
//   base: "",
//   sm: "",
//   md: "",
//   lg: "",
//   xl: "",
//   "2xl": "",
// };
const headingFontSize = {
  base: "16px",
  sm: "20px",
  md: "28px",
  lg: "36px",
  xl: "48px",
  "2xl": "56px",
};

const largeFontSize = {
  base: "14px",
  sm: "16px",
  md: "20px",
  lg: "24px",
  xl: "32px",
  "2xl": "40px",
};

const bodyFontSize = {
  base: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "24px",
};
const smallFontSize = {
  base: "10px",
  sm: "12px",
  md: "14px",
  lg: "16px",
  xl: "18px",
  "2xl": "20px",
};

const textStyles = defineTextStyles({
  bigHeading: {
    value: {
      fontSize: headingFontSize,
      lineHeight: 1.2,
      fontWeight: 900,
      letterSpacing: "-0.02em",
    },
  },
  subHeading: {
    value: {
      fontSize: largeFontSize,
      lineHeight: 1.2,
      letterSpacing: "-0.02em",
    },
  },
  largeBody: {
    value: {
      fontSize: largeFontSize,
      lineHeight: 1.2,
    },
  },
  smallHeading: {
    value: {
      fontSize: bodyFontSize,
      lineHeight: 1.2,
      fontWeight: 900,
      letterSpacing: "-0.01em",
    },
  },
  body: {
    value: {
      fontSize: bodyFontSize,
      lineHeight: 1.2,
    },
  },
  smallBody: {
    value: {
      fontSize: smallFontSize,
      lineHeight: 1.2,
    },
  },
});

export const system = createSystem(defaultConfig, {
  theme: {
    breakpoints,
    textStyles,
    tokens: {
      fonts: {
        heading: { value: `"Bricolage Grotesque", sans-serif` },
        body: { value: `"Bricolage Grotesque", sans-serif` },
      },
      colors: {
        primary: {
          light: { value: "#EFE1FF" },
          dark: { value: "#AD6AFF" },
        },
        secondary: {
          light: { value: "#FDF6DC" },
        },
        white: { value: "#ffffff" },
        offBlack: { value: "#030204" },
      },
    },
  },
});
